module.exports = __webpack_public_path__ + "img/sayings.5e7cd2b.webp";